import { useAppDispatch } from "@/app/hooks";
import { unlinkClient } from "@/features";
import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type Props = {
  isOpen: boolean;
  id: number;
  client_id: number;
  onSuccess: () => void;
  toggle: () => void;
};

export const UnlinkClient = ({
  isOpen,
  id,
  client_id,
  onSuccess,
  toggle,
}: Props) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      await dispatch(unlinkClient({ id, client_id })).unwrap();
      onSuccess();
      toggle();
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Unlink Client</ModalHeader>
      <ModalBody>
        <p>
          Are you sure want to <span className="fw-bold">UNLINK</span> this
          client?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => toggle()} disabled={isSubmitting}>
          Close
        </Button>
        <Button
          color="primary"
          onClick={() => onSubmit()}
          disabled={isSubmitting}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
